<!-- 协会查询 -->
<template>
<div class="" >
    <div class="detail-wrap">  
        <el-tabs v-model="activeName" type="border-card" style="min-height: 550px;" @tab-click="changeTab">
            <el-tab-pane label="协会查询" name="first">
                <el-form :model="searchForm" ref="searchForm" :inline="true"> 
                    <el-form-item label="协会名称">
                        <el-input v-model="searchForm.memberId" placeholder="请输入协会名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="searchQuery('searchForm')">查询</el-button>               
                        <!-- <el-button @click="resetForm('searchForm')">重置</el-button> -->
                    </el-form-item>        
                </el-form>
                <el-table border :data="tableData" style="margin-top:10px;">
                    <el-table-column  prop="index"   label="序号"   width="100" align="center" sortable/>
                    <el-table-column  prop="clubName"  label="协会名称"  width="200" align="center"/>
                    <el-table-column  prop="clubId"    label="协会账号" align="center"/>
                    <el-table-column  prop="grade"  label="协会积分" align="center" sortable/>
                    <el-table-column  prop="level"  label="协会等级" align="center" sortable/>
                    <el-table-column  fixed="right" label="操作"  width="120" align="center" v-if="adminRoles">
                        <template slot-scope="scope">
                            <el-button   @click="toAuditTabs(scope.row)" 
                            type="text" size="medium">查会员并审核</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="入会退会审核" name="second" v-if="roles">                
                <el-form :model="searchForm2" ref="searchForm2" :inline="true"> 
                    <el-form-item label="会员名称">
                        <el-input v-model="searchForm2.username" placeholder="请输入会员名称"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <el-input v-model="searchForm2.phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item  label="状态">
                        <el-select v-model="searchForm2.status" style="width:100%">
                            <el-option 
                                v-for="item in statusOptionsAudit"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="searchQuery2('searchForm2')">查询</el-button> 
                        <el-button @click="handleExport" type="success" size="medium">导出</el-button>              
                        <!-- <el-button @click="resetForm('searchForm')">重置</el-button> -->
                    </el-form-item>        
                </el-form>
                <el-row style="text-align: center;font-size: 20px;">{{ clubTitle }}</el-row>
                <!-- :default-sort="{prop: 'username',   order: 'ascending'}" -->
                <el-table border :data="tableDataMember" style="margin-top:10px;" >
                    <el-table-column  prop="index"   label="序号"   width="60" align="center" />
                    <el-table-column  prop="username"  label="会员名称"  width="110" align="center" sortable 
                        :sort-method="sortByPinyin"  />
                    <el-table-column  prop="clubPosition"    label="协会职务"  width="110" align="center" sortable/>
                    <el-table-column  prop="clubNameInfo"    label="协会角色"  width="110" align="center" sortable/>
                    <el-table-column  prop="phone"  label="手机号"  width="120" align="center"/>                    
                    <el-table-column  prop="grade"  label="积分" width="90" align="center" sortable/>
                    <el-table-column  prop="level"  label="等级" width="90" align="center" sortable/>
                    <el-table-column  prop="area"  label="省市"  width="110" align="center"/>
                    <el-table-column  prop="reason"  label="入会理由" width="150" align="center">
                        <template slot-scope="scope">
                            <el-tooltip 
                                :content="scope.row.reason" 
                                placement="top-end"
                                :disabled="!shouldShowTooltip(scope.row.reason)"
                            >
                            <div class="multiline-ellipsis" :title="scope.row.reason">
                            {{ scope.row.reason }}
                            </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="date"  label="申请日期" width="100" align="center"/>
                    <el-table-column  prop="status"  label="状态" align="center"/>
                    <el-table-column  fixed="right" label="操作"  width="120" align="center"> 
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status === '入会申请' || scope.row.status === '正常'" @click="updateDialog(scope.row)" type="text" size="medium">修改</el-button>   
                            <el-button v-if="scope.row.status === '入会申请' || scope.row.status === '退会申请'" 
                            @click="auditDialog(scope.row)" type="text" size="medium">审核</el-button>
                        </template>                                   
                    </el-table-column>
                </el-table>
                <!-- <pagination
                    style="text-align:right"
                    v-show="total > 10"
                    :total="total"
                    :page.sync="queryParams.page"
                    :limit.sync="queryParams.pagesize"
                    @pagination="getAssocicationPage"
                /> -->
            </el-tab-pane>
        </el-tabs>
    </div>
    <!-- 审核对话框 -->
    <el-dialog :title="titleMember" :visible.sync="open" width="600px" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="150px">      
        <el-form-item label="会员账号" prop="userId">
            <el-input v-model="form.userId" :disabled="disabled"/>
        </el-form-item> 
        <el-form-item label="协会职务" prop="clubPosition">
            <el-input v-model="form.clubPosition"  placeholder="请输入协会职务"/>
        </el-form-item>  
        <el-form-item label="协会角色" prop="clubName" v-if="clubRoleShow">
            <el-select v-model="form.clubName" style="width:100%">
                <el-option 
                    v-for="item in clubRoleOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>  
        <el-form-item label="审核" prop="flag" v-if="!clubRoleShow">
            <el-radio-group v-model="form.flag">
                <el-radio :label="1">同意</el-radio>
                <el-radio :label="2">拒绝</el-radio>
            </el-radio-group>
        </el-form-item>   
        <el-form-item label="状态" prop="status">               
            <template  v-if="clubRoleShow">
                <el-select v-model="form.newStatus" style="width:100%">
                <el-option 
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
            </el-select>
            </template>
            <template v-else>
                <el-input v-model="form.status"  :disabled="disabled"/>
            </template>
        </el-form-item>               
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
    </div>
    </el-dialog>
</div>
</template>

<script>
import pagination  from '@/components/Pagination'
import Breadcrumb from '@/components/Breadcrumb'
import PageBack from '@/components/PageHeader'
import pinyin from 'pinyin';

export default {
    components:{
        pagination,
        Breadcrumb,
        PageBack
    },
    data() {
        return {
            activeName: 'first',
            searchForm:{
                memberId: '',
            },
            searchForm2:{
                phone: '',
                status: '',
                username: '',
            },
            form: {
                userId: '',
                clubPosition: '',
                flag: '',
                status: '',
                newStatus: '',
                clubName: '',
            },
            queryParams: {
                page: 1,
                pagesize: 10
            },
            tableData: [],  
            tableDataMember: [],
            myClubTableData:[],
            amount: 0,  
            total: 0,
            titleMember: '',
            open: false,
            disabled: false,
            clubRoleShow: false,
            flagShow: false,
            clubRoleOption: [],
            clubPositionOption: [],
            rules:{
                userId: [
                    { required: true, message: "", trigger: "blur" }
                ],
                clubPosition: [
                    { required: true, message: "请输入协会职务", trigger: "blur" }
                ],
                flag: [
                    { required: true, message: "请选择", trigger: "" }
                ],
                clubName: [
                    { required: false, message: "请选择", trigger: "" }
                ],
                status: [
                    { required: false, message: "请选择", trigger: "" }
                ]
            },
            statusOptions: [
                {value:1,label:'正常'},
                {value:2,label:'入会申请'},
                {value:3,label:'入会拒绝'},
                {value:4,label:'退会申请'},
                {value:5,label:'已退会'},
            ],
            statusOptionsAudit: [
                {value:1,label:'正常'},
                {value:2,label:'入会申请'},
                {value:4,label:'退会申请'},
            ],
            AssocicationId: '',
            exportData: [],
            clubTitle: ''
        }   
    },
    created() {
     
    },
    mounted() {
        this.getClubRole()
        this.getUserAssocication()
        this.getAssocicationMember()
    },
    watch:{
        'form.flag'(value){
            if(value === 2){
                this.rules.clubPosition[0].required = false
            }else{
                this.rules.clubPosition[0].required = true
            }
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        },
        roles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员'|| value === '掼蛋协会' || value === '掼蛋俱乐部'){
                return true
            }else{
                return false
            }    
        },
        adminRoles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员'){
                return true
            }else{
                return false
            }    
        }    
    },
    methods: { 
        // 获取协会角色
        getClubRole(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 11,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.clubRoleOption = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })
                }
            })
        },    
        // 模糊查询协会
        getUserAssocication(){
            let params = {
                opcode: this.$code.SearchAssociation,
                v_name: this.searchForm.memberId,
                i_client_no: 0 ,
                i_starrating: 0,
                opcode: 1070,
                pagesize: "",
                size: "",
                v_city: "",               
                v_phone: "",
                v_provice: "",
            }
            this.$api._requestAPI(params).then(res => {
                if (res.IsSuccess) {   
                    let result = res.Data.DataTable
                    this.tableData = result.map((item,index) =>{
                        return{
                            index: index + 1,
                            clubId: item['账号'],
                            clubName: item['协会(俱乐部)全称'],
                            grade: item['积分'],
                            level:item['等级'],                                
                            des: item['协会(俱乐部)简称'],
                        }
                    })
                }
            })
        },
        // 协会的 所有会员 14
        getAssocicationMember(){
            let params = {
                opcode: this.$code.AssociationMember,
                c_status: this.searchForm2.status,
                v_name: this.searchForm2.username,
                v_phone: this.searchForm2.phone,
                pagesize: this.queryParams.pagesize,
                size: this.queryParams.page,
            }
            this.$api.requestAPI(params).then(res => {
                if (res.IsSuccess) {   
                    let result = res.Data.DataTable
                    
                    let arrList = result.map((item,index) =>{
                        let newStatus = this.statusOptions.filter(i=>i.label === item['状态'])

                        return{
                            index: index + 1,
                            indexXH: item['序号'],
                            userId: item['会员账号'],
                            userFullName: item['会员全称'],
                            username: item['会员简称'] || item['会员全称'],
                            reason: item['入会理由'],
                            clubPosition: item['协会职务'],
                            clubNameInfo: item['协会角色'] === '1' ? '选手': item['协会角色'] === '2'?'裁判':"",
                            clubName: item['协会角色'],
                            grade: item['会员积分'],
                            level:item['会员等级'],                                
                            status: item['状态'],
                            newStatus: newStatus[0].value,
                            date:  this.$help.formatDate(item['申请日期']),
                            phone: item['手机号'],
                            area: item['省']+ item['市'],
                            province: item['省'],
                            city: item['市'],
                        }
                    })                    
                 
                    this.tableDataMember = arrList.filter((i)=>i.status === '正常' || i.status === '入会申请' ||i.status === '退会申请')
                    
                    // 拼音排序
                    this.tableDataMember = this.tableDataMember.map(item => ({
                        ...item,
                        pinyin: this.convertToPinyin(item.username)
                    }));
                    console.log('pinyin1',this.tableDataMember)
                    this.total = this.tableDataMember.length 
                     // 导出Excel数据
                     this.exportData = this.tableDataMember.map(item=>{
                        return{
                            '序号': item.indexXH,
                            '会员账号': item.userId,
                            '会员全称': item.userFullName,
                            '会员简称': item.username,
                            '手机号': item.phone,
                            '省': item.province,
                            '市': item.city,
                            '会员积分': item.grade,
                            '会员等级':item.level,       
                            '入会理由': item.reason,
                            '协会职务': item.clubPosition,
                            '协会角色': item.clubNameInfo,
                            '状态': item.status,
                            '日期': item.date,   
                        }
                    })
                }else{
                    this.tableDataMember = []
                }
            })
        },    
        updateDialog(row){
            this.titleMember = '修改会员信息'
            this.disabled = true
            this.open = true
            this.clubRoleShow = true
            this.rules.clubName[0].required = true
            this.rules.status[0].required = true
            this.form = {...row}
            // console.log(this.form)
        }, 
        // 审核  
        auditDialog(row){
            this.titleMember = row.status + '审核'
            this.disabled = true
            this.open = true
            this.clubRoleShow = false
            this.rules.clubName[0].required = false
            this.rules.status[0].required = false
            this.form = {...row}
        },
        submitForm(form){
            this.$refs[form].validate((valid)=>{
                if(valid){
                   if(this.clubRoleShow){
                        this.updateSubmit()
                   }else{
                        this.auditSubmit()
                   }
                }else{
                    console.log('error submit!!');
                    return false;
                }
            })          
        },
        // 审核
        auditSubmit(){
            let { userId, status,flag,clubPosition} = this.form
            let params = {
                opcode:this.$code.AssociationAudit,
                i_member_no: userId,
                c_status: flag,
                i_duties: clubPosition,
                v_status: status === '入会申请' ? 1 : 2,
            };
            // console.log('审核',params)
            this.$api.requestAPI(params).then( res =>{
                if(res.IsSuccess){
                    this.$message.success(res.Message);  
                    this.getAssocicationMember()   
                    this.open = false          
                }else{
                    this.$message.error(res.Message);
                }  
            }).catch( error =>{
                console.log(error);
            })  
        },
        // 更新
        updateSubmit(){
            let { userId, newStatus,clubName, clubPosition} = this.form
            let params = {
                opcode:this.$code.AssociationUpdate,
                i_member_no: userId,
                c_status: newStatus,
                i_duties: clubPosition,
                i_type: clubName
            };
            // console.log('修改',params)
            this.$api.requestAPI(params).then( res =>{
                if(res.IsSuccess){
                    this.$message.success(res.Message);  
                    this.getAssocicationMember()   
                    this.open = false          
                }else{
                    this.$message.error(res.Message);
                }  
            }).catch( error =>{
                console.log(error);
            })  
        },
        cancel(){
            this.open = false
            this.resetForm('form')
        },
        searchQuery() {
            this.getUserAssocication()
        },
        searchQuery2() {
            if(this.AssocicationId !==''){
                this.getAllMemberAssocication()
            }else{
                this.getAssocicationMember()
            }            
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 管理员查询协会下所有会员 并审核
        getAllMemberAssocication(){
            let params = {
                opcode: this.$code.ClubAllMemberAudit,
                i_client_no: this.AssocicationId,
                c_status: this.searchForm2.status,
                v_name: this.searchForm2.username,
                v_phone: this.searchForm2.phone,
                pagesize: this.queryParams.pagesize,
                size: this.queryParams.page,
            }
            this.$api._requestAPI(params).then(res => {
                if (res.IsSuccess) {   
                    let result = res.Data.DataTable
                    let arrList = result.map((item,index) =>{
                        let newStatus = this.statusOptions.filter(i=>i.label === item['状态'])

                        return{
                            index: index + 1,
                            indexXH: item['序号'],
                            userId: item['会员账号'],
                            userFullName: item['会员全称'],
                            username: item['会员全称'] || item['会员简称'],
                            reason: item['入会理由'],
                            clubPosition: item['协会职务'],
                            clubNameInfo: item['协会角色'] === '1' ? '选手': item['协会角色'] === '2'?'裁判':"",
                            clubName: item['协会角色'],
                            grade: item['会员积分'],
                            level:item['会员等级'],                                
                            status: item['状态'],
                            newStatus: newStatus[0].value,
                            date:  this.$help.formatDate(item['申请日期']),
                            phone: item['手机号'],
                            area: item['省']+ item['市'],
                            province: item['省'],
                            city: item['市'],
                        }
                    })
                    this.tableDataMember = arrList.filter((i)=>i.status === '正常' || i.status === '入会申请' ||i.status === '退会申请')

                    // 拼音排序
                    this.tableDataMember = this.tableDataMember.map(item => ({
                        ...item,
                        pinyin: this.convertToPinyin(item.username)
                    }));
                    console.log('pinyin2',this.tableDataMember)

                    this.total = this.tableDataMember.length 
                    // 导出Excel数据
                    this.exportData = this.tableDataMember.map(item=>{
                        return{
                            '序号': item.indexXH,
                            '会员账号': item.userId,
                            '会员全称': item.userFullName,
                            '会员简称': item.username,
                            '手机号': item.phone,
                            '省': item.province,
                            '市': item.city,
                            '会员积分': item.grade,
                            '会员等级':item.level,       
                            '入会理由': item.reason,
                            '协会职务': item.clubPosition,
                            '协会角色': item.clubNameInfo,
                            '状态': item.status,
                            '日期': item.date,   
                        }
                    })
                }else{
                    this.tableDataMember = []
                }
            })
        }, 
        changeTab(){
            if(this.activeName === 'first'){
                this.getUserAssocication()
                this.AssocicationId = ''
                this.clubTitle = ''
                this.tableDataMember = []
            }else{
                this.queryParams.page = 1 
                this.getAssocicationMember()
            }
        },
        // 管理员查询会员并审核
        toAuditTabs(row){
            this.activeName = 'second'
            this.AssocicationId = row.clubId
            this.clubTitle = row.clubName
            if(row.clubId){
                this.getAllMemberAssocication()
            }
        },
        getAssocicationPage(){
            if(this.AssocicationId !==''){
                this.getAllMemberAssocication()
            }else{
                this.getAssocicationMember()
            }    
        },
        handleExport(){
            if(this.exportData.length > 0){
                this.$help.ExportFormData(this.exportData,'会员信息')
            }else{
                this.$message.error('暂无数据')
            }
        },
        // 中文转拼音工具函数
        convertToPinyin(name) {
            if (!name) return '';
            const cleanedName = name.trim();
            return pinyin(cleanedName, {
                style: pinyin.STYLE_NORMAL, // 标准拼音格式
                heteronym: false           // 禁用多音字模式
            }).map(item => item.join('')).join('');
        },
        // 自定义拼音排序方法
        sortByPinyin(a, b) {
           return (a.pinyin || '').localeCompare(b.pinyin || '');
        },
        // 判断是否应该显示tooltip（根据内容长度粗略判断）
        shouldShowTooltip(content) {
            if (!content) return false;
            // 这里可以根据实际需求调整判断逻辑
            // 简单的判断：如果内容超过50个字符，就显示tooltip
            return content.length > 30;
        }
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
/* 多行文本省略样式 */
.multiline-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制显示3行 */
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  max-height: 4.5em; /* 3行 * 1.5行高 */
  word-break: break-word;
  cursor: default;
}

/* 鼠标悬停时显示完整内容（可选） */
.multiline-ellipsis:hover {
  background-color: #f5f7fa;
}

/* 调整表格行高以适应多行文本 */
.el-table .cell {
  line-height: 1.5;
}
</style>


// WEBPACK FOOTER //
// src/views/association/association.vue